import { render } from "./SimpleSectionHeader.vue?vue&type=template&id=71952b3c"
import script from "./SimpleSectionHeader.vue?vue&type=script&lang=js"
export * from "./SimpleSectionHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__